import triot from 'triot';
import messageValidation from 'static/script/utils/message-validation';
import contactService from 'static/script/app/data/contact-service';
import breakpoints from 'static/script/utils/breakpoints';
import 'static/output/script/riot-core-tags';
import 'static/script/app/ui/comment-feedback/comment-feedback-modal-mixin';
import 'static/style/pages/hybrid-settings';
import onReady from 'utils/on-ready';

export default () => {
    onReady(() => {
        let commentFeedbackService = contactService({
            url: '/profile/feedback/reply-to-negative-feedback',
            gaEvent_success: {
                category: 'Profile',
                label: 'Comment Feedback - message sent',
                action: 'Navigation',
                userTriggered: true
            },
            gaEvent_error: {
                category: 'Profile',
                label: 'Comment Feedback - message error',
                action: 'Navigation',
                userTriggered: true
            }
        });

        triot.mount('[data-contact-seller-modal]', 'comment-feedback-modal', {
            contactService: commentFeedbackService,
            validator: messageValidation,
            breakpoints: breakpoints
        });
    });
};
